export default __webpack_public_path__ + "static/media/student-sign-up-pear-practice.64e5c439.png";